import React from 'react';
import { FiGrid, FiList } from 'react-icons/fi';
import { useTheme } from '../../contexts/ThemeContext';

interface Props {
  view: 'cards' | 'table';
  onChange: (view: 'cards' | 'table') => void;
}

export const ViewToggle: React.FC<Props> = ({ view, onChange }) => {
  const { darkMode } = useTheme();
  const active = darkMode ? 'bg-gray-700 text-white' : 'bg-gray-200 text-gray-800';
  const inactive = darkMode ? 'text-gray-500 hover:text-gray-300' : 'text-gray-400 hover:text-gray-600';

  return (
    <div className={`flex rounded-lg overflow-hidden border ${darkMode ? 'border-gray-700' : 'border-gray-300'}`}>
      <button className={`p-1.5 ${view === 'cards' ? active : inactive}`} onClick={() => onChange('cards')} title="Card view">
        <FiGrid className="w-3.5 h-3.5" />
      </button>
      <button className={`p-1.5 ${view === 'table' ? active : inactive}`} onClick={() => onChange('table')} title="Table view">
        <FiList className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
